const ja = {
  about: {
    desc:
      "私たちの使命は、シームレスで使いやすい無料アプリケーションを開発し、さまざまなプラットフォームで作業を効率化し生産性を高めることです。私たちは、品質やユーザー体験を損なうことなく、日常生活をより便利にするツールを作ることを信条としています。",
    title: "私たちについて",
    portfolio: {
      title: "ポートフォリオ",
      mpc: {
        name: "マリッジポイント計算機",
        desc:
          "🃏 マリッジカードゲームのコンパニオン：マリッジポイント計算機（センターコレクション）モバイルアプリ！使いやすく共有可能なインターフェースでポイント計算にもう悩みません。",
        playStore: "Playストアで入手",
        appStore: "スマートテレビStoreで入手",
        web: "ウェブアプリを開く",
      },
      led: {
        name: "LED & ネオンサインボード",
        desc1:
          "あなたのデバイスをデジタルサインボードに変身させます。スマートフォン、タブレット、またはスマートテレビにキャストして明るいメッセージを表示できます。",
        desc2: "コンサートやライブイベントに最適です。",
        playStore: "Playストアで入手",
        appStore: "スマートテレビStoreで入手",
        web: "ウェブアプリを開く",
      },
      tax: {
        name: "タックスアドバイザー ネパール",
        desc: "税金を計算し、節税方法を見つけましょう。",
        web: "ウェブアプリを開く",
      },
      installOnMobile: "インストール",
      openWebApp: "ウェブアプリを開く",
    },
    team: {
      title: "チーム紹介",
      manoj: {
        name: "マノジ・シュレスタ",
        role: "最高経営責任者 (CEO)",
        desc:
          "10年以上の経験を持つITビジネスの専門家。ITを活用してビジネス課題を解決する高い専門知識を持っています。",
        profile: "プロフィールを見る",
      },
      pujan: {
        name: "プジャン・シュレスタ",
        role: "最高技術責任者 (CTO)",
        desc:
          "7年以上の経験を持つテックエキスパート。会社の技術面全般を担当し、フルスタック開発者としても活躍しています。",
        profile: "プロフィールを見る",
      },
      learnMore: "詳しく見る", // fallback for generic button
    },

    description: "私たちのアプリケーションへようこそ！最高の体験を提供します。",
  },
  share: {
    title: "共有",
    description:
      "アプリをインストールするには、友達にQRコードをスキャンしてもらってください！",
  },
  privacy: {
    title: "プライバシーポリシー",
    date: "2024年1月1日",
    description: "当アプリをご利用いただきありがとうございます。お客様のプライバシーは私たちにとって重要です。本プライバシーポリシーは、当社がどのように情報を収集、利用、保護するかを説明します。",
    sections: {
      1: {
        title: "収集する情報",
        body: "個人情報: お客様が自発的に提供された場合、氏名、メールアドレスなどの連絡先情報を収集することがあります。\n\n利用データ: アプリの利用状況（訪問したページや利用した機能など）を収集します。\n\nデバイス情報: パフォーマンスやトラブルシューティングのため、デバイスの種類、OS、アプリバージョンを収集することがあります。"
      },
      2: {
        title: "情報の利用方法",
        body: "サービスの提供および改善のため。\n\nユーザー体験のパーソナライズのため。\n\nお問い合わせへの対応やサポートのため。\n\n重要なお知らせやプロモーションの送信（同意がある場合のみ）。"
      },
      3: {
        title: "情報の共有",
        body: "お客様の個人情報を販売することはありません。以下の場合に情報を共有することがあります:\n\nアプリ運営を支援する信頼できる第三者サービスと。\n\n法令遵守や権利保護のため。"
      },
      4: {
        title: "データの安全管理",
        body: "不正アクセス、損失、悪用からデータを守るため、適切な技術的・組織的対策を実施しています。"
      },
      5: {
        title: "お客様の権利",
        body: "お客様には以下の権利があります:\n\n当社が保有する情報へのアクセス。\n\n訂正または削除の請求。\n\n同意の撤回。"
      },
      6: {
        title: "第三者サービス",
        body: "当アプリは、独自のプライバシーポリシーを持つ第三者サービス（例: 分析や広告）を利用する場合があります。各サービスのポリシーもご確認ください。"
      },
      7: {
        title: "ポリシーの変更",
        body: "本ポリシーは随時更新されることがあります。変更時はアプリ内で新しい発効日とともにお知らせします。"
      },
      8: {
        title: "お問い合わせ",
        body: "本ポリシーについてご質問やご不明点がある場合は、shrestha.applications@gmail.com までご連絡ください。"
      }
    }
  },
  terms: {
    title: "利用規約",
    description: "アプリを利用する前に、これらの規約をよくお読みください。",
    sections: {
      1: {
        title: "利用規約の受諾",
        body:
          "本アプリケーションへアクセスまたは利用することで、これらの利用規約に従うことに同意したものとみなされます。",
      },
      2: {
        title: "規約の変更",
        body:
          "当社はいつでも本規約を変更・修正・改定する権利を有します。変更後もアプリを利用し続けることで、新しい規約への同意となります。",
      },
      3: {
        title: "ユーザーの責任",
        body:
          "ユーザーはアプリを合法的な目的でのみ利用し、アプリや他のユーザーに損害を与える行為を行わないことに同意します。",
      },
      4: {
        title: "知的財産権",
        body:
          "本アプリのすべてのコンテンツ、機能、機能性はShrestha Appsの独占的財産であり、著作権等の法律によって保護されています。",
      },
      5: {
        title: "第三者サービス",
        body:
          "本アプリには、当社が所有・管理しない第三者ウェブサイトやサービスへのリンクが含まれる場合があります。当社は第三者サイトの内容や運用について責任を負いません。",
      },
      6: {
        title: "保証の否認",
        body:
          "本アプリは「現状有姿」および「利用可能な範囲」で提供されます。当社はアプリの運用や可用性について明示または黙示の保証をいたしません。",
      },
      7: {
        title: "責任の制限",
        body:
          "Shrestha Appsは、ユーザーのアプリ利用に関連して発生するいかなる損害についても責任を負いません。",
      },
      8: {
        title: "補償",
        body:
          "ユーザーは、本アプリの利用に起因または関連して発生する請求、損害、費用についてShrestha Appsを免責することに同意します。",
      },
      9: {
        title: "利用停止",
        body:
          "当社は、理由の如何を問わず、予告なくいつでもユーザーのアプリ利用を停止または終了する権利を有します。",
      },
      10: {
        title: "準拠法",
        body: "本規約は、ネパールの法律に準拠し解釈されます。",
      },
      11: {
        title: "お問い合わせ",
        body:
          "本規約に関するご質問は、shresthaapps@gmail.com までお問い合わせください。",
      },
      12: {
        title: "完全合意",
        body:
          "これらの規約は、アプリの利用に関してあなたとShrestha Appsとの間の完全な合意を構成します。",
      },
    },
    title: "利用規約",
    description: "ご利用前に利用規約をよくお読みください。",
  },
  footer: {
    copyright: "© {year} Shrestha Apps",
    allRightsReserved: "全著作権所有",
    tagline: "生活をより便利にするアプリを作っています。",
    nepal: "ネパール",
    japan: "日本",
    usa: "アメリカ",
    email: "メール",
  },
};

export default ja;
